import { gql } from '@apollo/client'

export const upsertUserTour = gql`
  mutation UpsertUserTour($record: UserTourInput!) {
    upsertUserTour(record: $record) {
      _id
    }
  }
`
